<pxc-action-buttons
  class="mr-2 flex-nowrap gap-1!"
  optionButtonAppearance="outline"
  size="s"
  [actionButtons]="actionButtons"
  [actions]="actions"
  [entity]="entity$ | async" />
